document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('CompressionLevelModal');
  if (!modal) return;

  function openModal() {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';

    const trigger = document.querySelector('[data-open-compression-info]');
    const currentLevel = trigger?.closest('.m-compression-level')?.querySelector('.m-compression-level__dial')?.className.match(/dial--(\w+)/)?.[1];

    modal.querySelectorAll('.m-compression-modal__level').forEach(function (el) {
      el.classList.toggle('m-compression-modal__level--active', el.dataset.level === currentLevel);
    });

    if (currentLevel) {
      const target = document.getElementById('CompressionLevel-' + currentLevel.charAt(0).toUpperCase() + currentLevel.slice(1));
      if (target) setTimeout(function () { target.scrollIntoView({ block: 'start' }); }, 50);
    }
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-compression-info]')) {
      e.preventDefault();
      openModal();
    }
    if (e.target.closest('[data-compression-close]')) {
      closeModal();
    }
  });
});